import { c as _c } from "react/compiler-runtime";
import { FC } from 'react';
interface Props {
  size?: string | number;
  className?: string;
}
const Cross: FC<Props> = t0 => {
  const $ = _c(4);
  const {
    size: t1,
    className
  } = t0;
  const size = t1 === undefined ? 16 : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path d="M12.7461 4.40192L11.739 3.39478L7.74609 7.38763L3.75324 3.39478L2.74609 4.40192L6.73895 8.39478L2.74609 12.3876L3.75324 13.3948L7.74609 9.40192L11.739 13.3948L12.7461 12.3876L8.75324 8.39478L12.7461 4.40192Z" fill="currentColor" />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== className || $[2] !== size) {
    t3 = <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 16 16" fill="none" className={className}>{t2}</svg>;
    $[1] = className;
    $[2] = size;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
export default Cross;